<template>
   <div class="row justify-content-center">
      <!-- Start col -->
      <div class="col-md-8 col-lg-10 col-xl-10">
         <div class="card m-b-20" style="margin: 1% 5% 5% 5%">
               <div class="card-body">
                  <div class="invoice">
                     <div class="invoice-head">
                           <div class="row">
                              <div class="col-12 col-md-7 col-lg-7">
                                 <div class="invoice-logo">
                                       <img :src="mainLogo" class="img-fluid" alt="product">
                                 </div>
                              </div>
                              <div class="col-12 col-md-5 col-lg-5">
                                 <div class="invoice-name">
                                       <h5 class="text-uppercase mb-3">Pedido</h5>
                                       <p class="mb-1">{{orden.orden}}</p>
                                       <p class="mb-0">{{dateTimeFormat(orden.fecha_preventa)}}</p>
                                       <h4 class="text-success mb-0 mt-3">{{explicitMoneyFormat(orden.total_pagar)}}</h4>
                                 </div>
                              </div>
                           </div>
                     </div> 
                     <div class="invoice-billing">
                           <div class="row">
                              <div class="col-sm-6 col-md-4 col-lg-4">
                                 <div class="invoice-address">
                                       <h6 class="mb-3">Vendido a:</h6>
                                       <h6 class="text-muted">{{currentUserName}}</h6>
                                       <ul class="list-unstyled">
                                          <li>{{address}}</li>
                                       </ul>
                                       <h6 class="mb-3">Metodo de pago:</h6>
                                       <h6 class="text-muted">
                                          {{ formasPago[mibrime_info.ID_Forma_Pago] }}
                                       </h6>                             
                                 </div>
                              </div>
                              <div class="col-sm-6 col-md-4 col-lg-4">                            
                              </div>                                                      
                              <div class="col-sm-12 col-md-4 col-lg-4">
                                 <div class="invoice-address">
                                       <div class="card">
                                          <div class="card-body bg-secondary-rgba text-center">                                    
                                             <h6 class="mb-3">Fecha de entrega:</h6>
                                             <span class="badge badge-primary-inverse font-18">{{regularDateFormat(orden.fecha_entrega)}}</span>
                                          </div>
                                       </div>                             
                                 </div>
                              </div>

                           </div>
                     </div>  
                     <div class="invoice-summary">
                           <div class="table-responsive ">
                              <table class="table table-borderless">
                                 <thead>
                                       <tr>
                                          <th scope="col">ID</th>
                                          <th scope="col">Producto</th>
                                          <th scope="col">Cantidad</th>
                                          <th scope="col">Precio</th>
                                          <th scope="col" class="text-right">Total</th>
                                       </tr>
                                 </thead>
                                 <tbody>
                                       <tr v-for="(line, idx) in orderLines" :key="idx">
                                          <th scope="row">{{line.product_code}}</th>
                                          <td>{{line.product_name}}</td>
                                          <td>{{line.pieces}}</td>
                                          <td>{{explicitMoneyFormat(line.precio_u)}}</td>
                                          <td class="text-right">{{explicitMoneyFormat(line.total)}}</td>
                                       </tr>
                                 </tbody>
                              </table>
                           </div>
                     </div>
                     <div class="invoice-summary-total">
                           <div class="row">
                              <div class="col-md-12 order-2 order-lg-1 col-lg-5 col-xl-6">
                                 <div class="order-note">
                                    <p class="mb-3"></p>
                                    <h6>Notas:</h6>
                                    <p style="font-size:12px">{{orden.notas_orden}}</p>
                                 </div> 
                                 <div class="order-total table-responsive">
                                       <table>
                                          <tbody>                                        
                                             <tr>
                                                <td><h6>Monto de Regalo :</h6></td>
                                                <td><h5> -${{gifts.monto_regalo}}</h5></td>
                                             </tr>
                                             <tr>
                                                <td><h6>Piezas :</h6></td>
                                                <td><h5> {{gifts.piezas_regalo}}</h5></td>
                                             </tr>                                                                                                                                    
                                          </tbody>
                                       </table>
                                 </div>                                                                                           
                              </div>
                              <div class="col-md-12 order-1 order-lg-2 col-lg-7 col-xl-6">
                                 <div class="order-total table-responsive ">
                                       <table class="table table-borderless text-right">
                                          <tbody>
                                             <tr>
                                                <td>Subtotal :</td>
                                                <td>{{explicitMoneyFormat(orden.subtotal)}}</td>
                                             </tr>
                                             <tr>
                                                <td>IVA :</td>
                                                <td>{{explicitMoneyFormat(orden.iva)}}</td>
                                             </tr>     
                                             <tr>
                                                <td>IEPS :</td>
                                                <td>{{explicitMoneyFormat(orden.ieps)}}</td>
                                             </tr>                                       
                                             <tr>
                                                <td>Descuentos :</td>
                                                <td>{{explicitMoneyFormat(orden.descuento)}}</td>
                                             </tr>                                            
                                             <tr>
                                                <td><h4 class="text-dark mb-0 mt-3">Total a pagar :</h4></td>
                                                <td><h4 class="text-dark mb-0 mt-3">${{orden.total_pagar}}</h4></td>
                                             </tr>
                                          </tbody>
                                       </table>
                                 </div>
                              </div>
                           </div>
                     </div>
                     <div class="invoice-meta">
                           <div class="row">
                              <div class="col-sm-6 col-md-4 col-lg-4">
                                 <div class="invoice-meta-box">
                                       <h6 class="mb-3">Términos y condiciones</h6>
                                       <ul class="pl-3" style="font-size:12px">
                                          <li>Precio en pesos mexicanos.</li>  
                                          <li>Entregas sujetas a cambios sin previo aviso.</li>  
                                       </ul>
                                 </div>
                              </div>
                              <div class="col-sm-6 col-md-4 col-lg-4">
                                 <div class="invoice-meta-box">
                                       <h6 class="mb-3">Contacto</h6>
                                       <ul class="list-unstyled" style="font-size:11px">
                                          <!--
                                          <li><i class="feather icon-aperture mr-2"></i>www.example.com</li>
                                          -->
                                          <li><i class="feather icon-mail mr-2"></i>contacto@grupobrime.com</li>  
                                          <li><i class="feather icon-phone mr-2"></i>{{PhonesSucursal}}</li>
                                       </ul>
                                 </div>
                              </div>
                              <div class="col-sm-6 col-md-4 col-lg-4">
                                 <div class="invoice-meta-box">
                                       <h6 class="mb-3">Mi sucursal</h6>
                                       <ul class="list-unstyled" style="font-size:11px">
                                          <!--
                                          <li><i class="feather icon-aperture mr-2"></i>www.example.com</li>
                                          -->                                          
                                          <li><i class="feather icon-phone mr-2"></i>{{ruta_sucursal_info.nombre_sucursal}}</li>
                                          <li><i class="feather icon-phone mr-2"></i>{{ruta_sucursal_info.direccion}}</li>
                                       </ul>
                                 </div>
                              </div>
                           </div>
                     </div> 
                     <div class="invoice-footer">
                           <div class="row align-items-center">
                              <div class="col-md-6">
                                 <p class="mb-0">Gracias por tu compra.</p>
                              </div>
                              <div class="col-md-6">
                                 <div class="invoice-footer-btn">
                                            <button type="button" class="btn btn-info-rgba my-1 mr-2" @click.stop="getCFDI_Xml" ><i class="feather icon-arrow-down mr-2"></i>Descargar XML</button>
                                    <button type="button" class="btn btn-info-rgba my-1 mr-2" @click.stop="getCFDI_PDF" ><i class="feather icon-arrow-down mr-2"></i>Descargar PDF</button>
                                    <button type="button" class="btn btn-primary-rgba my-1 mr-2" @click.stop="getTicket" ><i class="feather icon-arrow-down mr-2"></i>Descargar Ticket</button>
                                    <a href="javascript:window.print()" class="btn btn-success-rgba py-1 font-16 mr-2"><i class="feather icon-printer mr-2"></i>Imprimir Ticket</a>

                                 </div>
                              </div>
                           </div>
                     </div>
                  </div>
               </div>
         </div>
      </div>
      <!-- End col -->
   </div>
</template>

<script>

import {mapState} from "vuex";
import formatHelper from "@mixins/formatHelper"
import dateHelper from "@mixins/dateHelper"
import {Order} from "../../classes/order"
import {OrderLine} from "../../classes/order_line"
import {Gifts_Order} from "../../classes/gifts_order"
import {Ruta_Sucursal} from "../../classes/ruta_sucursal"
import {MiBrime} from "../../classes/Mibrime"
export default {
   name: "TicketPage",
   mixins: [formatHelper, dateHelper],
   props: ['order_id'],
   data(){
      return {
         thumbnailUrl: "https://i.ibb.co/TcVZypR/mini-product.png",
         mainLogo: require('@assets/images/logos/mid-logo.png'),
         orden: new Order(),
         mibrime_info: new MiBrime(),
         orderLines: [],
         gifts: [],
         ruta_sucursal_info: new Ruta_Sucursal(),
         formasPago: {
            1: 'Efectivo',
            2: 'Tarjeta',
            3: 'Transferencia'
         }
      }
   },  
   async mounted(){
      await this.getOrderInfo();
      // Se valida que la orden pertenezca al usuario en sesión
      if(this.user.ID == this.orden.id_cliente){
         await this.getOrderDetailInfo();
         await this.getOrderGifts();
         await this.getRutaSucursalInfo();
         await this.getMibrimeInfo();
      }else{
         await this.$router.push({name: "cliente-inicio"})
      }
   },   
   computed: {
      ...mapState("cart", ["order_details", "amounts"]),
      ...mapState("auth", ["user", "is_logged"]),
      currentUserName(){
         return this.user.Nombre_negocio;
      },
      address(){
         const add = this.user.Direccion;
         const col = this.user.Colonia
         const mun = this.user.Municipio
         const st = this.user.Estado
         const cp = this.user.CP

         let fadd = `${add}, ${col}, ${mun}, ${st}`;
         if(cp != null){
            fadd = `${fadd}, CP: ${cp}`;
         }
         return fadd;
      },
      PhonesSucursal(){
         if (this.ruta_sucursal_info.telefono_1 == null && this.ruta_sucursal_info.telefono_2 == null){
            return "N/A"
         }
         if (this.ruta_sucursal_info.telefono_1 != null && this.ruta_sucursal_info.telefono_2 == null){
            return this.ruta_sucursal_info.telefono_1
         }
         if (this.ruta_sucursal_info.telefono_1 == null && this.ruta_sucursal_info.telefono_2 != null){
            return this.ruta_sucursal_info.telefono_2
         }
         return this.ruta_sucursal_info.telefono_1 + '/' + this.ruta_sucursal_info.telefono_2
      }    
   },  
   methods: {
      async getOrderInfo(){
         this.showLoader("Obteniendo información de orden ...")
         const res = await this.xget('/orden_info/'+this.order_id);
         if(res.success){
            this.setOrderInfo(res.data);
         }
         this.stopLoader()
      },      
      setOrderInfo(order){
         this.orden = Order.fromServiceOrder(order)
      },

      async getMibrimeInfo(){
         this.showLoader("Obteniendo información ...")
         const res = await this.xget('/orden_mibrime_info/'+this.order_id);
         if(res.success){
            this.setMibrimeInfo(res.data);
         }
         this.stopLoader()
      },

      setMibrimeInfo(mibrime_info){
         this.mibrime_info = MiBrime.fromServiceMibrime(mibrime_info)
      },

      async getOrderDetailInfo(){
         this.showLoader("Obteniendo información de productos ...")
         const res = await this.xget('/orden_detail_info/'+this.order_id);
         if(res.success){
        
            this.setOrderDetailInfo(res.data);
         }
         this.stopLoader()
      },      
      setOrderDetailInfo(rawLinesOrder){
         this.orderLines = [];
         rawLinesOrder.forEach(line => {
            this.orderLines.push(OrderLine.fromServiceOrderLines(line));
         });
      },
      async getOrderGifts(){
         this.showLoader("Obteniendo información de regalos ...")
         const res = await this.xget('/orden_gifts_info/'+this.order_id);
         if(res.success){
            this.setOrderGiftsInfo(res.data);
         }
         this.stopLoader()
      },      
      setOrderGiftsInfo(giftsOrder){
         this.gifts = Gifts_Order.fromServiceOrderGifts(giftsOrder)
      },
      async getRutaSucursalInfo(){
         this.showLoader("Obteniendo información de sucursal ...")
         const res = await this.xget('/rutaSucursalInfo/'+this.user.ID);
         if(res.success){
            this.setRutaSucursalInfo(res.data);
         }
         this.stopLoader()
      },
      setRutaSucursalInfo(rutaSucursalInfo){
         this.ruta_sucursal_info = Ruta_Sucursal.fromServiceRutaSucursal(rutaSucursalInfo)
      },              
      async getTicket(){
         this.showLoader("Descargando ticket....")

         axios({
               url: '/ticket_venta/'+this.order_id,
               method: 'GET',
               responseType: 'blob',
            }).then((response) => {
               var fileURL = window.URL.createObjectURL(new Blob([response.data]));
               var fileLink = document.createElement('a');
               fileLink.href = fileURL;
               fileLink.setAttribute('download', 'ticket.pdf');
               document.body.appendChild(fileLink);
               fileLink.click();
            });
         this.stopLoader()
      },  
      async getCFDI_Xml(){
         
         this.showLoader("Descargando CFDI ...") 
         const id = this.order_id;
         const clienteId = this.user.ID;
         const type = "XML";
         const res = await axios.get(
            `https://api.sidi-e.com/api/ordenes/cfdi/${id}/${clienteId}/${type}`
         );
         this.stopLoader()  
         if(res.data.data != null){
            window.open(res.data.data, "_blank");
            const a = document.createElement("a");
            a.click();  
         }
         else{
            this.errorNotifDialog("el cfdi no está disponible, intente más tarde")
            return;
         }          
      },
      async getCFDI_PDF(){
         this.showLoader("Descargando CFDI ...") 
         const id = this.order_id;
         const clienteId = this.user.ID;
         const type = "PDF";
         const res = await axios.get(
            `https://api.sidi-e.com/api/ordenes/cfdi/${id}/${clienteId}/${type}`
         );
         this.stopLoader()  
         if(res.data.data != null){
            window.open(res.data.data, "_blank");
            const a = document.createElement("a");
            a.click();  
         }
         else{
            this.errorNotifDialog("el cfdi no está disponible, intente más tarde")
            return;
         } 
      }
   }
}

</script>

<style>

</style>